export function roundToPrecision(num: number, decimalPoint: number): string {
    // Round to 10 decimal places to handle floating-point precision issues
    const roundedToTenDecimals = parseFloat(num.toFixed(10));

    // Round to the desired decimal points and return as string
    return roundedToTenDecimals.toFixed(decimalPoint);
}

roundToPrecision(12.123,2)
